import React from 'react'
import ValidationSchema from './ValidationSchema'
import { components } from 'cng-web-lib'
import ConnectorTranslationText from '../ConnectorTranslationText'
import { Card, CardContent, Grid } from '@material-ui/core'
import AccordionHeaderComponent from '../../../common/ui/AccordionHeaderComponent'


const {
  form: {
    field: {
      CngTextField
    }
  }, CngGridItem
} = components


function Fields({ ...props }) {

  const { disabled } = props
  const {
    connectorEndpoints, connectorEndpointName, connectorEndpointCode, connectorEndpointUrl
  } = ConnectorTranslationText()


  return (<>
      <Grid container spacing={3}>
        <CngGridItem xs={12} sm={12}>
          <Card>
            <CardContent>
              <Grid container>

                <AccordionHeaderComponent
                  title={connectorEndpoints} />

                <Grid container spacing={2}>
                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      required
                      name='name'
                      label={connectorEndpointName}
                      disabled={disabled}
                    />

                  </CngGridItem>

                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      required
                      name='code'
                      label={connectorEndpointCode}
                      disabled={disabled}
                    />
                  </CngGridItem>


                  <CngGridItem xs={12} sm={6}>
                    <CngTextField
                      required
                      name='endpoint'
                      label={connectorEndpointUrl}
                      disabled={disabled}
                    />
                  </CngGridItem>


                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </CngGridItem>
      </Grid>
    </>

  )
}


function toClientDataFormat(serverData) {
  return serverData
}

function toServerDataFormat(localData) {
  return localData
}

const DEFAULT_INITIAL_VALUES = {
  name: '', code: '', endpoint: ''
}

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES }, makeValidationSchema: ValidationSchema
}

const ConnectorEndpointsFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default ConnectorEndpointsFormProperties